import type { AviPillar } from "@/types";

export const AVI_PILLAR_OPTIONS = [
  { value: "e", label: "Environmental" },
  { value: "s", label: "Social" },
  { value: "g", label: "Governance" },
  { value: "t", label: "Technical" },
] as const satisfies ReadonlyArray<{ value: AviPillar; label: string }>;

export function normalizeAviPillar(value?: string | null): AviPillar | null {
  if (!value) return null;

  const normalized = value.trim().charAt(0).toLowerCase();
  return normalized === "e" || normalized === "s" || normalized === "g" || normalized === "t"
    ? normalized
    : null;
}

export function getAviPillarInitial(value?: string | null): string {
  return normalizeAviPillar(value)?.toUpperCase() ?? "—";
}
